import { RouteConfig } from "vue-router";

export const REmployerCompliance: RouteConfig = {
  path: "compliance",
  name: "EmployerCompliance",
  component: () =>
    import(
      /* webpackChunkName: "employer-compliance" */
      "./VEmployerCompliance.vue"
    ),
  meta: {
    title: "Compliance",
    legend: "Stay compliant with immigration regulations.",
    icon: "document-text-outline",
    newIcon: "file-text",
    childLabel: "Tasks",
    childLabels: ["Tasks", "Employees"],
  },
};
